import styled from 'styled-components'
import { screen } from '../styles/mq'
export const Svg = styled.svg`
  display: inline-block;
  width: 28px;

  @media (min-width: ${screen.m}) {
    width: 32px;
  }
`

export const IconLinkedIn = () => {
  return (
    <Svg viewBox="0 0 72 72">
      <g fill="none" fillRule="evenodd">
        <path
          d="M8,72 L64,72 C68.418278,72 72,68.418278 72,64 L72,8 C72,3.581722 68.418278,-8.11624501e-16 64,0 L8,0 C3.581722,8.11624501e-16 -5.41083001e-16,3.581722 0,8 L0,64 C5.41083001e-16,68.418278 3.581722,72 8,72 Z"
          fill="var(--main)"
        />
        <path
          d="M62,62 L51.315625,62 L51.315625,43.8021149 C51.315625,38.8127542 49.4197917,36.0245323 45.4707031,36.0245323 C41.1746094,36.0245323 38.9300781,38.9261103 38.9300781,43.8021149 L38.9300781,62 L28.6333333,62 L28.6333333,27.3333333 L38.9300781,27.3333333 L38.9300781,32.0029283 C38.9300781,32.0029283 42.0260417,26.2742151 49.3825521,26.2742151 C56.7356771,26.2742151 62,30.7644705 62,40.051212 L62,62 Z M16.349349,22.7940133 C12.8420573,22.7940133 10,19.9296567 10,16.3970067 C10,12.8643566 12.8420573,10 16.349349,10 C19.8566406,10 22.6970052,12.8643566 22.6970052,16.3970067 C22.6970052,19.9296567 19.8566406,22.7940133 16.349349,22.7940133 Z M11.0325521,62 L21.769401,62 L21.769401,27.3333333 L11.0325521,27.3333333 L11.0325521,62 Z"
          fill="var(--dark)"
        />
      </g>
    </Svg>
  )
}

export const IconEmail = () => {
  return (
    <Svg viewBox="0 0 72 72">
      <path
        d="M8,72 L64,72 C68.418278,72 72,68.418278 72,64 L72,8 C72,3.581722 68.418278,-8.11624501e-16 64,0 L8,0 C3.581722,8.11624501e-16 -5.41083001e-16,3.581722 0,8 L0,64 C5.41083001e-16,68.418278 3.581722,72 8,72 Z"
        fill="var(--main)"
      />
      <g transform="translate(3, 3) scale(0.9)">
        <g transform="matrix(1.156904,0,0,1.180272,-6.001489,-9.730543)">
          <path
            d="M60.61,28.537L60.61,48.955C60.61,51.571 58.443,53.695 55.774,53.695L16.836,53.695C14.167,53.695 12,51.571 12,48.955L12,28.537C12,25.921 14.167,23.797 16.836,23.797L55.774,23.797C58.443,23.797 60.61,25.921 60.61,28.537Z"
            fill="none"
            stroke="var(--dark)"
            strokeWidth="4px"
          />
        </g>
        <g transform="matrix(0.879173,0,0,0.882952,4.394465,4.21374)">
          <path
            d="M6.102,18.508C15.847,25.627 35.949,39.661 35.949,39.661L66.155,17.955"
            fill="none"
            stroke="var(--dark)"
            strokeWidth="5px"
          />
        </g>
      </g>
    </Svg>
  )
}
